import React, { useEffect, useState } from "react";
import divider from "../../../../images/Vector 11.png";
import camera from "../../../../images/cameragreycolor.png";
import "./addproduct.scss";
import axios from "axios";
import arrow from "../../../../images/dropdown1.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import SellerNavigationComponent from "./SellerNavigationComponent";
const baseUrl = process.env.REACT_APP_BASEURL;
const AddProduct = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [fullColor, setFullColor] = useState([]);
  const [fullVariation, setVariation] = useState([]);
  const [category, setSelectedCategory] = useState("");
  const [colors, setColors] = useState([]);
  const [atltext2, setAtltext2] = useState("");
  const [metatitle2, setMetatitle2] = useState("");
  const [metadescription2, setMetadescription2] = useState("");
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [checkbox5, setCheckbox5] = useState(false);
  const [checkbox6, setCheckbox6] = useState(false);
  const [checkbox7, setCheckbox7] = useState(false);

  const [atltext3, setAtltext3] = useState("");
  const [metatitle3, setMetatitle3] = useState("");
  const [metadescription3, setMetadescription3] = useState("");

  const [attributes, setAttributes] = useState([]);
  const [allpickup, setAllpickup] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [subcategory, setSelectedSubcategory] = useState("");
  const [selectedAttribute1, setSelectedAttribute1] = useState([]);
  const [newsubcategory2, setnewSubcategory2] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedArrays, setSelectedArray] = useState([]);
  const [warrenty, setWarrenty] = useState("");
  const [hsn, setHsn] = useState("");
  const [selectedNewsubcategory, setSelectedNewsubcategory] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [newsubcategory, setnewSubcategory] = useState([]);
  const [newsubcategory1, setSelectedCategory1] = useState("");
  const [brands, setBrands] = useState([]);
  const [pickupvalue, setpickupvalue] = useState("");
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [MRP, setMRP] = useState("");

  const [price1, setPrice1] = useState("");
  const [sellerPrice, setSellerPrice] = useState("");

  const [stock, setStock] = useState("");
  const [color, setColor] = useState("");
  const [attribute, setAttribute] = useState("");
  const [sku, setSku] = useState("");
  const [gst, setGst] = useState("");
  const [weight, setWeight] = useState("");
  const [length, setLength] = useState("");
  const [breadth, setBreadth] = useState("");
  const [height, setHeight] = useState("");
  const [discount, setDiscount] = useState("");
  const [newBrand, setNewBrand] = useState("");
  const [description, setDescription] = useState("");
  const [specification, setSpecification] = useState("");
  const state = useSelector((state) => state.sellers);
  const { sellerAuth } = state;
  console.log(sellerAuth, "auth");
  const [metatitle1, setMetatitle1] = useState("");
  const [metadescription1, setMetadescription1] = useState("");
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const [atltext1, setAtltext1] = useState("");
  const [atltext4, setAtltext4] = useState("");
  const [metatitle4, setMetatitle4] = useState("");
  const [metadescription4, setMetadescription4] = useState("");
  const [sellers, setSellers] = useState("");

  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [delivaryCharge, setDelivaryCharge] = useState("");
  const [shippingFee, setShippingFee] = useState("");
  const [maxorderquantity, setMaxorderquantity] = useState("");
  const [checkbox, setCheckbox] = useState("");

  const [delivarycharge, setDelivarycharge] = useState("");

  const [details, setDetails] = useState("");
  const [selectedImage1, setSelectedImage1] = useState(null);
  const [selectedImage2, setSelectedImage2] = useState(null);
  const [selectedImage3, setSelectedImage3] = useState(null);
  const [selectedValues1, setSelectedValues1] = useState("");
  const [selectedValues2, setSelectedValues2] = useState("");
  const [selectedValues3, setSelectedValues3] = useState([]);
  const [selectedValues4, setSelectedValues4] = useState("");
  const [selectedValues5, setSelectedValues5] = useState("");
  const [selectedValues6, setSelectedValues6] = useState("");
  const [selectedValues7, setSelectedValues7] = useState("");
  const [selectedValues8, setSelectedValues8] = useState("");
  const [selectedValues9, setSelectedValues9] = useState("");
  const [selectedValues10, setSelectedValues10] = useState("");
  const [selectedValues11, setSelectedValues11] = useState("");
  const [selectedValues12, setSelectedValues12] = useState("");
  const [selectedValues13, setSelectedValues13] = useState("");
  const [selectedValues14, setSelectedValues14] = useState("");
  const [selectedValues15, setSelectedValues15] = useState("");

  useEffect(() => {
    const item = localStorage.getItem("sellerregisterInfo");
    console.log(item, "sellerregisterInfo");

    setSellers(JSON.parse(item));
  }, []);
  console.log(sellers?._id, "sellers");
  useEffect(() => {
    const fetchBrands = async () => {
      const response = await axios.get(`${baseUrl}/api/brand`);
      setBrands(response.data);
      console.log(response.data, "rrr");
      if (response.data.length > 0) {
        setNewBrand(response.data[0]._id);
      }
    };
    fetchBrands();
  }, []);
  useEffect(() => {
    const fetchColors = async () => {
      const response = await axios.get(`${baseUrl}/api/color/`);
      setColors(response.data);
    };
    fetchColors();
  }, []);
  const handleImageChange = (event, value) => {
    console.log(value, "value");
    if (value === "1") {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setSelectedImage(null);
      }
    } else if (value === "2") {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage1(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setSelectedImage1(null);
      }
    } else if (value === "3") {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage2(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setSelectedImage2(null);
      }
    } else if (value === "4") {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage3(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setSelectedImage3(null);
      }
    }
  };

  useEffect(() => {
    const fetchAttributes = async () => {
      const response = await axios.get(`${baseUrl}/api/attribute/all`);
      setAttributes(response.data);
    };
    fetchAttributes();
  }, []);
  useEffect(() => {
    const fetchPickuplocations = async () => {
      const response = await axios.get(
        `${baseUrl}/api/order/allpickuplocation`
      );

      setAllpickup(response.data);
    };
    fetchPickuplocations();
  }, []);
  const firstValue = allpickup[0];
  const secondValue = allpickup[1];
  const thirdValue = allpickup[2];
  const fourthValue = allpickup[3];

  const handleInputChange = (attributeId, value) => {
    setSelectedValues1({
      attributeId:attributeId,
      value:value
    })

  };
  const handleInputChange1 = (attributeId, value) => {
    setSelectedValues3({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
    // setSelectedArray([selectedValues1,selectedValues3])
    // console.log(selectedArrays,'selectedArrays');
  };
  const handleInputChange2 = (attributeId, value) => {
    setSelectedValues5({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  const handleInputChange3 = (attributeId, value) => {
    setSelectedValues7({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  const handleInputChange4 = (attributeId, value) => {
    setSelectedValues9({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  const handleInputChange5 = (attributeId, value) => {
    setSelectedValues11({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  const handleInputChange6 = (attributeId, value) => {
    setSelectedValues13({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  const handleInputChange7 = (attributeId, value) => {
    setSelectedValues15({
      attributeId: attributeId,
      value: value,
    });
    console.log(selectedValues3, "selectedvalue3");
  };
  useEffect(() => {
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id); // Check the entire object
  
    const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller: sellerInfoObject?._id,
        }
      );
      setDetails(response.data);
    };
    fetchDetails();
  }, []);
  console.log(details, "11");
  useEffect(() => {
    const fetchCategories = async () => {
      const response = await axios.get(`${baseUrl}/api/Ecom/category`);
      setCategories(response.data);
      setSelectedCategory(response.data[0]?._id); // set the first category as default
      if (response.data.length > 0) {
        setCategoryId(response.data[0]._id);
      }
    };
    fetchCategories();
  }, []);

  const fetchSubcategories = async () => {
    const response = await axios.get(
      `${baseUrl}/api/Ecom/category/${categoryId}/subcategories`
    );
    console.log(response.data, "pppppppp");
    setSubcategories(response.data);
    if (response.data.length > 0) {
      setSelectedSubcategory(response.data[0]._id);
    }
  };
  useEffect(() => {
    if (categoryId) {
      fetchSubcategories();
    }
  }, [categoryId]);
  const handleCheckBoxChange = (event) => {
    const selectedOptionId = event.target.value;
    const isChecked = event.target.checked;

    // Add or remove the selected option from the state based on the checkbox status
    if (isChecked) {
      setSelectedAttribute1((prevSelected) => [
        ...prevSelected,
        selectedOptionId,
      ]);
    } else {
      setSelectedAttribute1((prevSelected) =>
        prevSelected.filter((id) => id !== selectedOptionId)
      );
    }
  };
  const fetchSubcategories1 = async () => {
    const response = await axios.get(
      `${baseUrl}/api/Ecomsubcategory/${subcategory}/newsubcategories`
    );
    console.log(response.data, "qq");
    setnewSubcategory2(response.data);
    if (response.data.length > 0) {
      setSelectedNewsubcategory(response.data[0]._id);
    }
  };
  useEffect(() => {
    if (subcategory) {
      fetchSubcategories1();
    }
  }, [subcategory]);
  const handleCheckBoxChange1 = (event) => {
    const selectedOptionId = event.target.value;
    const isChecked = event.target.checked;

    // Add or remove the selected option from the state based on the checkbox status
    if (isChecked) {
      setSelectedColor((prevSelected) => [...prevSelected, selectedOptionId]);
    } else {
      setSelectedColor((prevSelected) =>
        prevSelected.filter((id) => id !== selectedOptionId)
      );
    }
  };
  const handlenewsubCategoryChange = (event) => {
    setSelectedCategory1(event.target.value);
  };
  const handleStatusChange = async (value) => {
    console.log(value, "valueee");
    setpickupvalue(value);
  };
  const handleCategoryChange = async (event) => {
    setSelectedCategory(event.target.value);

    console.log(event.target.value, "qqq");
    const response = await axios.get(
      `${baseUrl}/api/Ecom/category/${event.target.value}/subcategories`
    );
    console.log(response.data, "ooo");
    setSubcategories(response.data);
    if (response.data.length > 0) {
      setSelectedSubcategory(response.data[0]._id);
    }
  };
  const handlesubCategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
    const fetchsubcategory = async () => {
      // console.log(event.target.value, "2222");
      const response = await axios.get(
        `${baseUrl}/api/Ecomsubcategory/${event.target.value}/newsubcategories`
      );
      console.log(response.data, "new");
      return setnewSubcategory(response.data);
    };
    fetchsubcategory();
  };
  const handleSubmit1 = () => {
    try {
      setSelectedArray([selectedValues1,selectedValues3,selectedValues5,selectedValues7,selectedValues9,selectedValues11,selectedValues13,selectedValues15])

      console.log(selectedValues1,"selectedArrays");
      const allColors = selectedColor?.map((item) => ({
        colorName: item,
        // image: image2,
      }));
      setFullColor(allColors);
      console.log(allColors, "ggggg");
      const variationObject = {
        attributes: selectedArrays,
        colors: allColors,
      };
      setVariation(variationObject);
      console.log(variationObject, "variationObject");
    } catch (e) {
      console.log(e);
    }
  };
  console.log(fullVariation, "lll");
  const handlebrandChange = (event) => {
    console.log(event.target.value, "ppp");
    setNewBrand(event.target.value);
  };

  console.log(shippingFee,'shippingfee');
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!productName) {
      toast.error("productName not entered");

      return;
    }
    // if (!price) {
    //   toast.error("MRP not entered");

    //   return;
    // }
    // if (!price1) {
    //   toast.error("Your price not entered");

    //   return;
    // }
    if (!height) {
      toast.error("height not entered");

      return;
    }
    if (!length) {
      toast.error("Length not entered");

      return;
    }
    if (!breadth) {
      toast.error("Breadth not entered");

      return;
    }
    if (!weight) {
      toast.error("Weight not entered");

      return;
    }
    if (!stock) {
      toast.error("Stock not entered");

      return;
    }
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id); // Check the entire object
  
    try {
      const formData = new FormData();
      const productName = document.getElementById("productName").value;
      const category = document.getElementById("category").value;
      const subcategory = document.getElementById("subcategory").value;
      const newsubcategory = document.getElementById("newsubcategory1").value;
      const shippingFee = document.getElementById("shippingFee").value;
      const maxorderquantity = document.getElementById("maxorderquantity").value;
      const image = document.getElementById("image").files[0];
      const image1 = document.getElementById("image1").files[0];
      const image2 = document.getElementById("image2").files[0];
      const image3 = document.getElementById("image3").files[0];
      // const price = document.getElementById("price1").value;
      const mrp = document.getElementById("MRP").value;
      const sellerPrice = document.getElementById("sellerPrice").value;
      const weight = document.getElementById("weight").value;
      const description = document.getElementById("description").value;
      const specification = document.getElementById("specification").value;
      const sku = document.getElementById("sku").value;
      const warrenty = document.getElementById("warrenty").value;
      const delivaryCharge = document.getElementById("delivaryCharge").value;
      const stock = document.getElementById("stock").value;
      formData.append("Ecomcategory", category);
      formData.append("warrenty", warrenty);
      formData.append("Ecomsubcategory", subcategory);
      formData.append("Ecomnewsubcategory", newsubcategory);
      formData.append("mrp", mrp);
      formData.append("Ecomdiscount", discount);
      formData.append("image", image);
      formData.append("image", image1);
      formData.append("image", image2);
      formData.append("image", image3);
      formData.append("shippingFee",shippingFee);
      formData.append("sku", sku);
      formData.append("weight", weight);
      formData.append("breadth", breadth);
      formData.append("specification", specification);
      formData.append("EcomproductName", productName);
      formData.append("gst", gst);
      formData.append("height", height);

      formData.append("hsn", hsn);
      formData.append("Ecomstock", stock);
      formData.append("codAvailable", checkbox);
      formData.append("maxQuantity", maxorderquantity);
      formData.append("alttext", atltext1);
      formData.append("alttext2", atltext2);
      formData.append("alttext3", atltext3);
      formData.append("alttext4", atltext4);

      formData.append("metatitle", metatitle1);
      formData.append("metatitle2", metatitle2);
      formData.append("metatitle3", metatitle3);
      formData.append("metatitle4", metatitle4);

      formData.append("metadescription1", metadescription1);
      formData.append("metadescription2", metadescription2);
      formData.append("metadescription3", metadescription3);
      formData.append("metadescription4", metadescription4);
      formData.append("sellerPrice", sellerPrice);
      formData.append("onstaraFee", fee?.onstarafee1);
      formData.append("fixedFee", fee?.fixedfee1);
      // formData.append("shippingFee", fee?.shippingfee1);
      formData.append("rtofee", fee?.rtofee);
      formData.append("total", fee?.total);
      formData.append("sellingPrice", fee?.grandTotal);
      formData.append("Ecomdescription", description);
      formData.append("Ecomprice", price);
      formData.append("deliveryCharge", delivaryCharge);
      formData.append("length", length);
      formData.append("Ecombrand", newBrand);
      formData.append("reseller",sellerInfoObject?._id);
      formData.append("variations", JSON.stringify(fullVariation));
      const response = await axios.post(
        `${baseUrl}/api/Ecomproduct/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",

            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      console.log(response.data, "vhhhhhhhhhhh");
      toast.success("Ecom product added successfully");
    } catch (error) {
      console.error(error);
      toast.error("Error");
    }
  };
  const [fee, setFee] = useState("");
  const getCurrentDate = () => {
    const options = {
      weekday: "short",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const currentDate = new Date().toLocaleDateString(undefined, options);
    return currentDate;
  };
  const handleClick = () => {
    console.log("click");

    if (!weight) {
      console.log("Weight not entered");
      toast.error("Weight is required");
      return;
    }

    if (!sellerPrice) {
      toast.error("Seller price not entered");

      return;
    }
    if (!gst) {
      toast.error("GST not entered");

      return;
    }

    const fetchsubcategory = async () => {
      const response = await axios.post(`${baseUrl}/api/fee/withprice`, {
        Ecomsubcategory: subcategory,
        sellerPrice: sellerPrice,
        weight: weight,
        Ecomnewsubcategory: newsubcategory,
        Ecomsubcategory: subcategory,
        
        deliveryCharge: delivaryCharge,
        gst: gst,
        Ecomdiscount: discount,
      });
      console.log(response.data, "new");
      return setFee(response.data);
    };

    fetchsubcategory();
  };

  const [showHi, setShowHi] = useState(false);
  const handleClick1 = () => {
    setShowHi(!showHi);
  };
  return (
    <div>
      <ToastContainer />
      <div style={{ display: "flex" }}>
        <SellerNavigationComponent />
        <img src={divider} className="divider" />
        <div>
          <form onSubmit={handleSubmit}>
            <p className="welcometext">Welcome, {details[0]?.Fullname}</p>
            <p className="todaysdate">{getCurrentDate()}</p>
            <p className="addproductmaintext">Add Product</p>
            <p className="productinformationmaintext">Product Information</p>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productnamemaintext">Product Name</p>
                <input
                  className="productnameinput"
                  id="productName"
                  value={productName}
                  onChange={(event) => setProductName(event.target.value)}
                />
              </div>
              <div className="brandmaindiv">
                <p className="productcategorymaintext">Select Brand</p>
                <select
                  id="brand"
                  className="productcategoryinput"
                  name="brand"
                  value={newBrand}
                  onChange={handlebrandChange}
                >
                  {brands?.map((obj) => (
                    <option key={obj._id} value={obj._id}>
                      {obj?.brand}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="productcategorymaintextOne">
                  Select Pickup Location
                </p>
                <select
                  id="seller"
                  className="productcategoryinputOne"
                  name="brand"
                  onChange={(event) => handleStatusChange(event.target.value)}
                >
                  <>
                    <option>{firstValue}</option>
                    <option>{secondValue}</option>
                    <option>{thirdValue}</option>
                    <option>{fourthValue}</option>
                  </>
                </select>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productcategorymaintext">Product Category</p>
                <select
                  id="category"
                  className="productcategoryinput"
                  name="category"
                  value={category}
                  onChange={handleCategoryChange}
                >
                  {categories?.map((obj) => (
                    <option key={obj?._id} value={obj?._id}>
                      {obj?.Ecomcategory}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="productwarrentydetails">
                  Product Warranty Details
                </p>
                <input
                  className="productwarrentyinput"
                  id="warrenty"
                  value={warrenty}
                  onChange={(event) => setWarrenty(event.target.value)}
                />
              </div>
              <div>
                <p className="productwarrentydetails">HSN</p>
                <input
                  className="productwarrentyinputOne"
                  id="warrenty"
                  type="number"
                  value={hsn}
                  onChange={(event) => setHsn(event.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productcategorymaintext">Product Subcategory</p>
                <select
                  className="productcategoryinput"
                  id="subcategory"
                  name="subcategory"
                  value={subcategory}
                  onChange={handlesubCategoryChange}
                >
                  {subcategories?.map((subcategory) => (
                    <option key={subcategory?._id} value={subcategory?._id}>
                      {subcategory?.Ecomsubcategory}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="productweightOne">Breadth</p>
                <input
                placeholder=" Enter Your Product Breadth"
                  className="productcategoryinputTwo"
                  value={breadth}
                  id="weight"
                  type="number"
                  onChange={(event) => setBreadth(event.target.value)}
                />
                {/* <p className="productweighttext">Enter Your Product Breadth</p> */}
              </div>

              <div>
                <p className="productweight">Discount</p>
                <input
                type="number"
                placeholder=" Enter Your Product Discount"
                  className="productcategoryinputThree"
                  value={discount}
                  id="weight"
                  onChange={(event) => setDiscount(event.target.value)}
                />
                {/* <p className="productweighttext">Enter Your Product discount</p> */}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productcategorymaintext">
                  Product NewSubcategory
                </p>
                <select
                  id="newsubcategory1"
                  className="productcategoryinput"
                  name="newcategory"
                  value={newsubcategory1}
                  onChange={handlenewsubCategoryChange}
                >
                  {newsubcategory2?.map((obj) => (
                    <option key={obj._id} value={obj._id}>
                      {obj?.Ecomnewsubcategory}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="skutextOne">GST</p>
                <input
                  className="skuinputOne"
                  value={gst}
                  id="gst"
                  type="number"
                  onChange={(event) => setGst(event.target.value)}
                />
              </div>
              <div>
                <p className="delivary">Delivery Charge</p>
                <input
                  className="skuinputTwo"
                  value={delivaryCharge}
                  type="number"
                  id="delivaryCharge"
                  onChange={(event) => setDelivaryCharge(event.target.value)}
                />
              </div>
            </div>
            
            {/* <input className="productcategoryinput" /> */}
            <p className="productdetailtext">Product Detail</p>
            <div style={{ display: "flex" }}>
              <div>
                <p className="mrptext">MRP</p>
                <input
                  className="mrpinput"
                  id="MRP"
                  name="MRP"
                  type="number"
                  value={MRP}
                  onChange={(event) => setMRP(event.target.value)}
                  placeholder="INR"
                />
                <p className="maximumretailprice">
                  Your product Maximum Retail Price
                </p>
              </div>
              <div>
                <p className="pricemaintext">Seller Price</p>
                <input
                  className="yoursellerpriceinput"
                  id="sellerPrice"
                  value={sellerPrice}
                  type="number"
                  onChange={(event) => {
                    setSellerPrice(event.target.value);
                  }}
                  placeholder="Price"
                />
                <p className="yoursellingpricetext">Set your selling price </p>
              </div>

              <div>
                <p className="skutextThree">SKU</p>
                <input
                  className="skuinputThree"
                  value={sku}
                  id="sku"
                  onChange={(event) => setSku(event.target.value)}
                />
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div>
                <p className="mrptext">Shipping Fee</p>
                <input
                  className="mrpinput"
                  id="shippingFee"
                  type="Number"
                  name="shippingFee"
                  value={shippingFee}
                  onChange={(event) => setShippingFee(event.target.value)}
                  // placeholder="INR"
                />
              
              </div>
              <div>
                <p className="pricemaintextone">Maximum Order Quantity</p>
                <input
                  className="yoursellerpriceinputone"
                  id="maxorderquantity"
                  type="Number"
                  value={maxorderquantity}
                  onChange={(event) => {
                    setMaxorderquantity (event.target.value);
                  }}
                  // placeholder="Price"
                />
              </div>

              <div style={{display:'flex'}}>
                <p className="productwarrentydetails" style={{marginTop:"20%"}}>COD Available?</p>
                <input
                style={{marginLeft:'22%',marginTop:'10px'}}
                type="checkbox"
                  id="sortorder"
                  checked={checkbox}
                  onChange={(event) => setCheckbox(event.target.checked)}
                />
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div>
                <p className="productweight">Weight</p>
                <input
                placeholder=" Weight"
                  className="productcategoryinput"
                  value={weight}
                  type="number"
                  id="weight"
                  onChange={(event) => setWeight(event.target.value)}
                />
                <p className="productweighttext">Enter Your Product Weight</p>
              </div>
              <div>
                <p className="productweightthree">Length</p>
                <input
                placeholder=" Length"
                  className="productcategoryinputFour"
                  value={length}
                  type="number"
                  id="weight"
                  onChange={(event) => setLength(event.target.value)}
                />
                <p className="productweighttextOne">Enter Your Product Length</p>
              </div>
              <div>
                <p className="productweight">Height</p>
                <input
                placeholder=" Height"
                  className="productcategoryinputFive"
                  value={height}
                  id="height"
                  type="number"

                  onChange={(event) => setHeight(event.target.value)}
                />
                <p className="productweighttext">Enter Your Product Height</p>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="stocknametext">Stock</p>
                <input
                  id="stock"
                  type="number"
                  className="stockinput"
                  value={stock}
                  onChange={(event) => setStock(event.target.value)}
                />
                <p className="itemstocknotforsale">
                  Item with 0 stock will automatically set to be "Not for Sale”
                </p>
              </div>
              <div className="onstarapiceandcharges">
                <p>Onstara Price & Charges</p>
                <input
                  className="priceandchargesinput"
                  value={fee?.grandTotal}
                />
              </div>
              <div
                className="viewchargesdiv"
                onClick={handleClick}
                style={{ display: "flex" }}
              >
                <p className="viewchargestext">View Charges</p>
                <img
                  src={arrow}
                  className="arrowimage"
                  onClick={handleClick1}
                />
                {/* <p onClick={handleClick1}>.</p> */}
              </div>
              {showHi && (
                <>
                <div className="viewchargesonclickbox">
                    <p>Onstara Fees:₹{fee?.onstarafee1}</p>
                    <p>Fixed Fee:₹{fee?.fixedfee1}</p>
                    {/* <p>Shipping:₹{fee?.shippingfee1}</p> */}
                    {!delivarycharge ? (
                      <p>Shipping: Free</p>
                    ) : (
                      <p>Shipping: ₹{delivarycharge}</p>
                    )}

                    <p>AD Fees:Free</p>
                    <p>Packing Fee:Free</p>
                  </div>
                </>
              )}
            </div>
            <div style={{ display: "flex" }}>
              <div className="variationdiv">
                <p className="variationtext">Variation</p>
                <p className="colors">Colors</p>
                {/* <input
                  id="color"
                  className="stockinput"
                  value={color}
                  onChange={(event) => setColor(event.target.value)}
                /> */}
                <div class="custom-select-wrapper">
                  <div class="custom-select">
                    <div class="custom-options">
                      {colors?.map((item, index) => (
                        <label key={item?._id} class="custom-option">
                          <input
                            type="checkbox"
                            name="selectedOptions"
                            value={item?._id}
                            checked={selectedColor?.includes(item?._id)}
                            onChange={handleCheckBoxChange1}
                          />
                          {item?.Ecomcolor}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="colors">Attributes</p>
                <div class="custom-select-wrapper">
                  <div class="custom-select">
                    <div class="custom-options">
                      {attributes?.map((item, index) => (
                        <label key={item?._id} class="custom-option">
                          <input
                            type="checkbox"
                            name="selectedOptions"
                            value={item?._id}
                            checked={selectedAttribute1.includes(item?._id)}
                            onChange={handleCheckBoxChange}
                          />
                          {item?.Ecomattribute}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div class="selected-attributes1">
                    {Array.isArray(selectedAttribute1) &&
                      selectedAttribute1.slice(0, 2).map((attributeId) => (
                        <>
                          <div style={{ flexDirection: "column" }}>
                            <input
                              type="text"
                              required
                              // key={attributeId}
                              value={selectedValues}
                              onChange={(e) => {
                                handleInputChange(attributeId, e.target.value);
                                // Call the second function here
                                setSelectedValues(e.target.value);
                              }}
                            />
                            <input
                              type="checkbox"
                              checked={checkbox1}
                              onChange={(event) =>
                                setCheckbox1(event.target.checked)
                              }
                            />
                            {checkbox1 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox2}
                                  value={selectedValues2}
                                  onChange={(e) => {
                                    handleInputChange1(
                                      attributeId,
                                      e.target.value
                                    );
                                    // Call the second function here
                                    setSelectedValues2(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox2}
                                  onChange={(event) =>
                                    setCheckbox2(event.target.checked)
                                  }
                                />
                              </>
                            )}

                            {checkbox2 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox3}
                                  value={selectedValues4}
                                  onChange={(e) => {
                                    handleInputChange2(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues4(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox3}
                                  onChange={(event) =>
                                    setCheckbox3(event.target.checked)
                                  }
                                />
                              </>
                            )}
                            {checkbox3 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox4}
                                  value={selectedValues6}
                                  onChange={(e) => {
                                    handleInputChange3(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues6(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox4}
                                  onChange={(event) =>
                                    setCheckbox4(event.target.checked)
                                  }
                                />
                              </>
                            )}

                            {checkbox4 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox5}
                                  value={selectedValues8}
                                  onChange={(e) => {
                                    handleInputChange4(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues8(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox5}
                                  onChange={(event) =>
                                    setCheckbox5(event.target.checked)
                                  }
                                />
                              </>
                            )}
                            {checkbox5 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox6}
                                  value={selectedValues10}
                                  onChange={(e) => {
                                    handleInputChange5(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues10(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox6}
                                  onChange={(event) =>
                                    setCheckbox6(event.target.checked)
                                  }
                                />
                              </>
                            )}

                            {checkbox6 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox7}
                                  value={selectedValues12}
                                  onChange={(e) => {
                                    handleInputChange6(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues12(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox7}
                                  onChange={(event) =>
                                    setCheckbox7(event.target.checked)
                                  }
                                />
                              </>
                            )}

                            {checkbox7 && (
                              <>
                                <input
                                  type="text"
                                  required
                                  checked={checkbox7}
                                  value={selectedValues14}
                                  onChange={(e) => {
                                    handleInputChange7(
                                      attributeId,
                                      e.target.value
                                    );
                                    setSelectedValues14(e.target.value);
                                  }}
                                />
                                <input
                                  type="checkbox"
                                  checked={checkbox7}
                                  onChange={(event) =>
                                    setCheckbox7(event.target.checked)
                                  }
                                />
                              </>
                            )}
                          </div>
                        </>
                      ))}
                  </div>
                  {/* <pre>
                    Selected Values: {JSON.stringify(selectedValues, null, 2)}
                  </pre> */}
                  <div onClick={handleSubmit1} className="confirmbutton">
                    <p className="confirmtext">Confirm</p>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="imagedotdiv">
                {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Selected"
                      className="imagedotdiv1"
                    />
                  ) : (
                    <img src={camera} className="cameraimage" />
                  )}

                  <div style={{ display: "flex" }}>
                    <p className="dragyourphotos">
                      Drag Your Images to Upload or
                    </p>

                    <input
                      type="file"
                      placeholder="Enter image"
                      id="image"
                      name="image"
                      style={{ width: "200px", marginTop: "10px" }}
                      value={image}
                      onChange={(event) => {
                        setImage(event.target.value);
                        handleImageChange(event, "1");
                      }}                    />
                  </div>
                  <input
                    className="alttext"
                    id="atltext1"
                    placeholder="Add Alttext"
                    value={atltext1}
                    onChange={(event) => setAtltext1(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metatitle"
                    placeholder="Add Meta title"
                    value={metatitle1}
                    onChange={(event) => setMetatitle1(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metadescription"
                    value={metadescription1}
                    placeholder="Add Meta description"
                    onChange={(event) =>
                      setMetadescription1(event.target.value)
                    }
                  />
                 
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="imagedotdiv">
                  {/* {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Selected"
                    className="imagedotdiv1"
                  />
                )} */}
                   {selectedImage1 ? (
                    <img
                      src={selectedImage1}
                      alt="Selected"
                      className="imagedotdiv1"
                    />
                  ) : (
                    <img src={camera} className="cameraimage" />
                  )}
                  <div style={{ display: "flex" }}>
                    <p className="dragyourphotos">
                      Drag Your Images to Upload or
                    </p>
                    {/* <label htmlFor="imageInput" className="browse">
                  Browse */}
                    <input
                      type="file"
                      placeholder="Enter image"
                      id="image1"
                      name="image1"
                      value={image1}
                      onChange={(event) => {
                        setImage1(event.target.value);
                        handleImageChange(event, "2");
                      }}                    />
                    {/* </label> */}
                  </div>
                  <input
                    className="alttext"
                    id="atltext1"
                    placeholder="Add Alttext"
                    value={atltext2}
                    onChange={(event) => setAtltext2(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metatitle"
                    placeholder="Add Meta title"
                    value={metatitle2}
                    onChange={(event) => setMetatitle2(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metadescription"
                    value={metadescription2}
                    placeholder="Add Meta description"
                    onChange={(event) =>
                      setMetadescription2(event.target.value)
                    }
                  />
                  
                </div>
              </div>
              <div className="imagedotdiv">
              {selectedImage2 ? (
                    <img
                      src={selectedImage2}
                      alt="Selected"
                      className="imagedotdiv1"
                    />
                  ) : (
                    <img src={camera} className="cameraimage" />
                  )}
                <div style={{ display: "flex" }}>
                  <p className="dragyourphotos">
                    Drag Your Images to Upload or
                  </p>

                  <input
                    type="file"
                    placeholder="Enter image"
                    id="image2"
                    name="image2"
                    style={{ width: "200px", marginTop: "10px" }}
                    value={image2}
                    onChange={(event) => {
                      setImage2(event.target.value);
                      handleImageChange(event, "3");
                    }}                  />
                </div>
                <input
                  className="alttext"
                  id="atltext1"
                  placeholder="Add Alt text"
                  value={atltext3}
                  onChange={(event) => setAtltext3(event.target.value)}
                />
                <input
                  className="alttext"
                  id="metatitle"
                  placeholder="Add Meta title"
                  value={metatitle3}
                  onChange={(event) => setMetatitle3(event.target.value)}
                />
                <input
                  className="alttext"
                  id="metadescription"
                  placeholder="Add Meta description"
                  value={metadescription3}
                  onChange={(event) => setMetadescription3(event.target.value)}
                />
               
              </div>
              <div className="imagedotdiv">
              {selectedImage3 ? (
                    <img
                      src={selectedImage3}
                      alt="Selected"
                      className="imagedotdiv1"
                    />
                  ) : (
                    <img src={camera} className="cameraimage" />
                  )}                <div style={{ display: "flex" }}>
                  <p className="dragyourphotos">
                    Drag Your Images to Upload or
                  </p>

                  <input
                    type="file"
                    placeholder="Enter image"
                    id="image3"
                    name="image3"
                    style={{ width: "200px", marginTop: "10px" }}
                    value={image3}
                    onChange={(event) => {
                      setImage3(event.target.value);
                      handleImageChange(event, "4");
                    }}                  />
                </div>
                <input
                  className="alttext"
                  id="atltext1"
                  placeholder="Add Alttext"
                  value={atltext4}
                  onChange={(event) => setAtltext4(event.target.value)}
                />
                <input
                  className="alttext"
                  id="metatitle"
                  placeholder="Add Meta title"
                  value={metatitle4}
                  onChange={(event) => setMetatitle4(event.target.value)}
                />
                <input
                  className="alttext"
                  placeholder="Add Meta description"
                  id="metadescription"
                  value={metadescription4}
                  onChange={(event) => setMetadescription4(event.target.value)}
                />
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Selected"
                    className="imagedotdiv1"
                  />
                )}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productdesciptiontext">Product Description</p>
                <textarea
                  placeholder=" Type Here..."
                  id="description"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                  className="productdesciptiontextinput"
                ></textarea>
              </div>

              <div>
                <p className="productdesciptiontext">Product Specification</p>
                <textarea
                  placeholder=" Type Here..."
                  id="specification"
                  value={specification}
                  onChange={(event) => setSpecification(event.target.value)}
                  className="productdesciptiontextinput"
                ></textarea>
              </div>
            </div>
            <button className="savebutton" type="submit">
              Save to Draft
            </button>
            <button className="Selladdbutton" type="submit">
            Sell and Add Another
            </button>
            <button className="sellbutton" type="submit">
              Sell
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
